import { sortBy } from 'lodash';
import session from '@/services/session';
import queries from './queries';

interface Results {
  count: number;
  result: Array<{
    id: string;
    name: string;
    type: string;
  }>;
}

const sessionHistoryKey = 'sh';

export const addToHistory = (value = '') => {

  // return current history if no value passed in
  // or if value already in history
  const trimmed = value.trim();
  const current = getHistory();
  if (!trimmed || current.includes(trimmed)) {
    return current;
  }

  // add new value to beginning of history and limit to 5 items
  const newHistory = [trimmed, ...current].slice(0, 5);
  session.set(sessionHistoryKey, newHistory.toString());
  return newHistory;
};

export const clearHistory = () => session.clear(sessionHistoryKey);

export const getHistory = () => {
  const history = session.get(sessionHistoryKey);
  return history && history.split(',') || [];
};

export const request = (
  value: string,
  params: any,
): Promise<Results> => (
    queries.search({
      value: `%${value}%`,
      ...params,
    })
    .then(response => {
      const [types] = response.user;
      const results: Results['result'] = [];
      let count = 0;

      for (const type in types) {
        const { aggregate, nodes } = types[type];
        count += aggregate.count;
        nodes.forEach(record => {
          results.push({
            ...record,
            type,
          });
        });
      }

      // sort by name
      const result = sortBy(results, ['name']);

      return {
        count,
        result,
      };
    })
);

export default {
  addToHistory,
  clearHistory,
  getHistory,
  request,
};
